<!-- Icon variant: Used in table action columns -->
@if (variant === 'icon') {
    <button
        class="action-icon action-icon-delete"
        [disabled]="isDisabled"
        (confirm)="delete.emit()"
        [appConfirm]="confirmOptions"
    >
        <i class="fa-light fa-trash"></i>
    </button>
}

<!-- Tree variant: Used in dropdown menus -->
@if (variant === 'tree') {
    <button
        class="block w-full px-3 py-2 text-start text-rose-600 no-underline hover:bg-rose-50 hover:no-underline"
        [disabled]="isDisabled"
        (confirm)="delete.emit()"
        [appConfirm]="confirmOptions"
    >
        <i class="fa-light fa-trash fa-fw me-2"></i>
        {{ 'translate_delete' | translate }}
    </button>
}

<!-- Tools variant: Used in tools section -->
@if (variant === 'tools') {
    <button
        class="btn btn-sm btn-white"
        [disabled]="isDisabled"
        (confirm)="delete.emit()"
        [appConfirm]="confirmOptions"
    >
        <i class="fa-light fa-trash"></i>
        <span class="hidden md:inline">
            {{ 'translate_delete' | translate }}
        </span>
    </button>
}
